export enum LOCATION_LICENSES_STORAGE_KEYS {
  DealerPreference = "location-licenses-dealer-preference",
  LocationPreference = "location-licenses-location-preference"
}
